var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOn = function SvgEyeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3)",
    fill: "none",
    stroke: "#495867",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "eye_on_Path 6246",
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "eye_on_Ellipse 164",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)"
  }))));
};
export default SvgEyeOn;